import type { Template } from "@/types";

export const PO_07_H2_V5: Template[] = [
    {
        id: "po-07-h2v5-01",
        name: "PO 01 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_01.png",
        size: [1190, 850],
        style: {},
        slots: [         
            { id: "1", x: 52, y: 240, width: 259, height: 182, rotation: 0, imageRotation: 0 },
            { id: "2", x: 52, y: 430, width: 259, height: 181, rotation: 0, imageRotation: 0 },
            { id: "3", x: 319, y: 240, width: 230, height: 371, rotation: 0, imageRotation: 0 },
            { id: "4", x: 692, y: 112, width: 197, height: 310, rotation: 0, imageRotation: 0 },
            { id: "5", x: 692, y: 430, width: 197, height: 309, rotation: 0, imageRotation: 0 },
            { id: "6", x: 897, y: 112, width: 196, height: 310, rotation: 0, imageRotation: 0 },
            { id: "7", x: 897, y: 430, width: 196, height: 309, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h2v5-02",
        name: "PO 02 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_02.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 52, y: 240, width: 259, height: 182, rotation: 0, imageRotation: 0 },
            { id: "2", x: 52, y: 430, width: 259, height: 181, rotation: 0, imageRotation: 0 },
            { id: "3", x: 319, y: 240, width: 230, height: 371, rotation: 0, imageRotation: 0 },
            { id: "4", x: 649, y: 165, width: 366, height: 520, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1023, y: 165, width: 109, height: 168, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1023, y: 341, width: 109, height: 168, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1023, y: 517, width: 109, height: 168, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h2v5-03",
        name: "PO 03 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_03.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 63, y: 165, width: 482, height: 273, rotation: 0, imageRotation: 0 },
            { id: "2", x: 63, y: 445, width: 326, height: 240, rotation: 0, imageRotation: 0 },
            { id: "3", x: 396, y: 445, width: 148, height: 240, rotation: 0, imageRotation: 0 },
            { id: "4", x: 649, y: 165, width: 366, height: 520, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1023, y: 165, width: 109, height: 168, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1023, y: 341, width: 109, height: 168, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1023, y: 517, width: 109, height: 168, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h2v5-04",
        name: "PO 04 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_04.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 62, y: 165, width: 369, height: 256, rotation: 0, imageRotation: 0 },
            { id: "2", x: 62, y: 429, width: 369, height: 256, rotation: 0, imageRotation: 0 },
            { id: "3", x: 438, y: 165, width: 106, height: 168, rotation: 0, imageRotation: 0 },
            { id: "4", x: 438, y: 341, width: 106, height: 168, rotation: 0, imageRotation: 0 },
            { id: "5", x: 438, y: 517, width: 106, height: 168, rotation: 0, imageRotation: 0 },
            { id: "6", x: 648, y: 228, width: 237, height: 393, rotation: 0, imageRotation: 0 },
            { id: "7", x: 893, y: 228, width: 237, height: 393, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h2v5-05",
        name: "PO 05 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_05.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 50, y: 216, width: 259, height: 418, rotation: 0, imageRotation: 0 },
            { id: "2", x: 317, y: 216, width: 240, height: 205, rotation: 0, imageRotation: 0 },
            { id: "3", x: 317, y: 429, width: 240, height: 205, rotation: 0, imageRotation: 0 },
            { id: "4", x: 649, y: 165, width: 366, height: 520, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1023, y: 165, width: 109, height: 168, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1023, y: 341, width: 109, height: 168, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1023, y: 517, width: 109, height: 168, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h2v5-06",
        name: "PO 06 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_06.png",
        size: [1190, 850],
        style: {},
        slots: [         
            { id: "1", x: 95, y: 171, width: 150, height: 250, rotation: 0, imageRotation: 0 },
            { id: "2", x: 95, y: 429, width: 150, height: 250, rotation: 0, imageRotation: 0 },
            { id: "3", x: 253, y: 171, width: 150, height: 250, rotation: 0, imageRotation: 0 },
            { id: "4", x: 253, y: 429, width: 150, height: 250, rotation: 0, imageRotation: 0 },
            { id: "5", x: 410, y: 171, width: 320, height: 508, rotation: 0, imageRotation: 0 },
            { id: "6", x: 738, y: 171, width: 356, height: 250, rotation: 0, imageRotation: 0 },
            { id: "7", x: 738, y: 429, width: 356, height: 250, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h2v5-07",
        name: "PO 07 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_07.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 96, y: 172, width: 150, height: 249, rotation: 0, imageRotation: 0 },
            { id: "2", x: 254, y: 172, width: 150, height: 249, rotation: 0, imageRotation: 0 },          
            { id: "3", x: 412, y: 172, width: 355, height: 249, rotation: 0, imageRotation: 0 },
            { id: "4", x: 96, y: 429, width: 355, height: 249, rotation: 0, imageRotation: 0 },
            { id: "5", x: 459, y: 429, width: 150, height: 249, rotation: 0, imageRotation: 0 },
            { id: "6", x: 617, y: 429, width: 150, height: 249, rotation: 0, imageRotation: 0 },
            { id: "7", x: 775, y: 172, width: 320, height: 506, rotation: 0, imageRotation: 0 }

        ],
    },

    {
        id: "po-07-h2v5-08",
        name: "PO 08 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_08.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 0, y: 275, width: 182, height: 300, rotation: 0, imageRotation: 0 },
            { id: "2", x: 190, y: 275, width: 182, height: 300, rotation: 0, imageRotation: 0 },
            { id: "3", x: 380, y: 275, width: 430, height: 300, rotation: 0, imageRotation: 0 },
            { id: "4", x: 818, y: 275, width: 182, height: 300, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1008, y: 275, width: 182, height: 146, rotation: 0, imageRotation: 0 },        
            { id: "6", x: 1008, y: 429, width: 87, height: 146, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1103, y: 429, width: 87, height: 146, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h2v5-09",
        name: "PO 09 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_09.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 96, y: 172, width: 150, height: 250, rotation: 0, imageRotation: 0 },
            { id: "2", x: 96, y: 430, width: 150, height: 250, rotation: 0, imageRotation: 0 },
            { id: "3", x: 254, y: 172, width: 150, height: 250, rotation: 0, imageRotation: 0 },
            { id: "4", x: 254, y: 430, width: 150, height: 250, rotation: 0, imageRotation: 0 },
            { id: "5", x: 412, y: 172, width: 356, height: 250, rotation: 0, imageRotation: 0 },
            { id: "6", x: 412, y: 430, width: 356, height: 250, rotation: 0, imageRotation: 0 },
            { id: "7", x: 776, y: 172, width: 319, height: 508, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h2v5-10",
        name: "PO 10 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_10.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 83, y: 0, width: 579, height: 850, rotation: 0, imageRotation: 0 },
            { id: "2", x: 670, y: 0, width: 177, height: 278, rotation: 0, imageRotation: 0 },
            { id: "3", x: 670, y: 286, width: 177, height: 278, rotation: 0, imageRotation: 0 },
            { id: "4", x: 670, y: 572, width: 177, height: 278, rotation: 0, imageRotation: 0 },
            { id: "5", x: 855, y: 0, width: 251, height: 421, rotation: 0, imageRotation: 0 },
            { id: "6", x: 855, y: 429, width: 251, height: 421, rotation: 0, imageRotation: 0 }
        ],
    }
];